<template>
  <div class="flex items-center w-screen h-screen z-0 absolute overflow-hidden">
    <img class="bg absolute inset-0 object-cover h-full w-full"
         src="/images/bg/bearbeitet_weniger_rost_0.jpg" alt="background-image"/>
    <div class="bg-overlay absolute inset-0 bg-gradient-to-b from-surface-900/40 to-surface-900/5"></div>
  </div>
  <div class="flex items-center content-center z-10 h-screen w-100 relative justify-center">
    <Container>
      <h1 class="font-bold text-right text-6xl text-white  my-6">{{ $t("pages.diag_plus_plus.diag_plus_plus") }}</h1>
      <div class="flex column items-center content-center justify-center">
        <Card class="max-w-lg w-full">
          <template #title>
            <div class="flex items-center">
              <IconDownload class="w-6 h-6 mr-2" :stroke-width="1.5"/>
              <div>
                {{ $t("pages.diag_plus_plus.diag_plus_plus_v", { v: currentVersion }) }}
              </div>
            </div>
          </template>
          <template #content>
            <p class="mb-6">{{$t('pages.diag_plus_plus.diag_plus_plus_message')}}</p>
            <p class="mb-6">{{$t('pages.diag_plus_plus.diag_plus_plus_message_2')}} <a :href="supportUrl" class="text-primary-600 text-base font-medium hover:underline">Service Desk</a></p>
            <p class="mb-6">{{$t('pages.diag_plus_plus.diag_plus_plus_message_3')}} ({{ $t('pages.diag_plus_plus.diag_plus_plus_message_4') }})</p>
          </template>
          <template #footer>
            <div class="flex flex-col gap-3">
                <Button :disabled="downloading" :label="$t('pages.diag_plus_plus.download_now')" size="large" class="w-full block" @click="download()" data-cy="diag-download">
                  <template #icon>
                    <IconDownload class="w-5 h-5 mr-1.5 hidden md:block" :stroke-width="2"/>
                  </template>
                </Button>
                <Button
                    :disabled="downloading"
                    :label="$t('pages.diag_plus_plus.diag_plus_plus_v_old', { v: '3.1.4' })"
                    size="large"
                    severity="secondary"
                    outlined
                    class="w-full block"
                    @click="download('old')"
                    data-cy="diag-download-old-version"
                >
                  <template #icon>
                    <IconDownload class="w-5 h-5 mr-1.5 hidden md:block" :stroke-width="2"/>
                  </template>
                </Button>
            </div>
          </template>
        </Card>
      </div>
    </Container>
  </div>
</template>

<script>

import {IconDownload, IconBug, IconPlus, IconSparkles, IconHeadset} from '@tabler/icons-vue';
import Container from "@/Components/Container.vue";
import {useDownloadLink, useDownloadResponse} from "@/Composables/DownloadLink.js";

export default {
  name: "DiagPlusPlusView",
  components: {
    Container,
    IconDownload,
  },
  data() {
    return {
      downloading: false,
      supportUrl: import.meta.env.VITE_CUSTOMER_SUPPORT_URL,
      appEnv: import.meta.env.VITE_APP_ENV ?? 'production',
    }
  },
  computed: {
    currentVersion() {
      if (this.appEnv === 'internal') {
        return '3.0.8';
      }

      return '3.2.0';
    }
  },
  methods: {
    async download(version = 'current') {
      this.downloading = true;

      try {
        this.$toast.add({
          severity: 'info',
          summary: this.$t('common.started'),
          detail: this.$t('common.download_has_started'),
          life: 3000
        });

        let response = await axios.post('diag-plus-plus/download', { version });

        useDownloadLink(response.data.url);

      } catch (e) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('common.error'),
          detail: this.$t('common.there_was_an_error_downloading_the_file'),
          life: 3000
        });

        console.error(e);
      } finally {
        this.downloading = false;
      }
    }
  },
}
</script>